module.exports = __webpack_public_path__ + "e98105a.ttf";